module.exports = [{"title":"איך זה עובד","target":"ampSection","type":"scroller","offset":-370,"mobOffset":80},{"title":"איך זה התחיל","target":"timeline","type":"scroller"},{"title":"איך זה נשמע","target":"pedals","type":"scroller"},{"title":"לאן זה הולך","target":"article","type":"scroller"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/nav-items.json
// module id = 33
// module chunks = 0